/**
 * Las reglas del usuario en el cliente: las mismas que aplica el servidor
 * (`apps/api/src/usuario.ts`), dichas antes de enviar para no gastar un intento.
 */
export const USUARIO_MIN = 3;
export const USUARIO_MAX = 24;

const PERMITIDO = /^[a-z0-9._]+$/;

export function normalizarUsuario(usuario: string): string {
  return usuario.trim().toLowerCase();
}

/** `null` si vale; si no, qué le pasa, en una frase que se puede enseñar tal cual. */
export function problemaDelUsuario(usuario: string): string | null {
  const limpio = normalizarUsuario(usuario);
  if (limpio.length < USUARIO_MIN) return `El usuario necesita al menos ${USUARIO_MIN} caracteres.`;
  if (limpio.length > USUARIO_MAX)
    return `El usuario puede tener como mucho ${USUARIO_MAX} caracteres.`;
  if (!PERMITIDO.test(limpio))
    return 'Usa solo letras, números, punto o guion bajo, sin tildes ni espacios.';
  return null;
}

/**
 * El correo que Better Auth exige y nadie ve. `.invalid` es un dominio reservado
 * (RFC 2606): no existe ni existirá, así que ahí no se puede enviar nada.
 */
export function correoInterno(usuario: string): string {
  return `${normalizarUsuario(usuario)}@usuarios.selflevel.invalid`;
}

/** Las cuentas antiguas entran con su correo; las nuevas, con el usuario. */
export function esCorreo(identificador: string): boolean {
  return identificador.includes('@');
}

/**
 * Si a esta cuenta le falta el código de recuperación (las de antes no lo tenían), y
 * si además le falta el usuario. `null` = no hay nada que pedir, o no se sabe (sin red).
 */
export function codigoPendiente(
  estado: { tieneCodigo: boolean; username: string | null } | null,
): { pedirUsuario: boolean } | null {
  if (!estado || estado.tieneCodigo) return null;
  return { pedirUsuario: estado.username === null };
}
